import style from './block.module.scss'
import { ReadingTime } from '../components'
import dayjs from 'dayjs'
import { ShareSocials } from '../components'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTranslation } from 'react-i18next'

const Block = ({ categories, publishing_date, thumbnail, reading_time, title }) => {
    const { t } = useTranslation()
    const socialsBreakpoint = useMediaQuery('(max-width: 1450px)')

    return (
        <div className={style.block}>
            <div className={style.image}>
                <ReadingTime min={reading_time} classNames={style.readingTime} />
                <img src={thumbnail} alt="couverture" />
                {!socialsBreakpoint && (
                    <ShareSocials title={title} vertical positionStyle={style.socials} />
                )}
            </div>
            <div className={style.infos}>
                <div>{`${t('Publié le')} ${dayjs(publishing_date).format('LL')}`}</div>
                <div>
                    {categories &&
                        categories.length > 0 &&
                        categories.map((el, index, arr) => (
                            <span>{index === arr.length - 1 ? el.name : el.name + ' - '}</span>
                        ))}
                </div>
            </div>
            <h1 className={style.title}>{title}</h1>
        </div>
    )
}

export default Block
